import React from "react";
import "../../css_files/Enquiry/EnquiryType.css";
import CloseForm from "../Master/CloseForm";

function EnquiryType({
  setShowEnquiryType,
  setShowServiceEnquiry,
  setTriggerEnquiry,
  triggerEnquiry,
  setEnquiryType,
}) {
  return (
    <section className="enquiry-type">
      <div>
        <h1>Create New Enquiry</h1>

        <p>Select Enquiry Type</p>
        <aside>
          <blockquote
            onClick={() => {
              setShowServiceEnquiry(true);
              setShowEnquiryType(false);
              setTriggerEnquiry({ ...triggerEnquiry, update: false });
              setEnquiryType("Service");
            }}
          >
            <i class="fa-solid fa-wrench"></i>
            <p>Service Request</p>
          </blockquote>
          <blockquote
            onClick={() => {
              setShowServiceEnquiry(true);
              setShowEnquiryType(false);
              setTriggerEnquiry({ ...triggerEnquiry, update: false });
              setEnquiryType("Parts");
            }}
          >
            <i class="fa-solid fa-box"></i>
            <p>Parts Request</p>
          </blockquote>
        </aside>
        <CloseForm close={setShowEnquiryType} />
      </div>
    </section>
  );
}

export default EnquiryType;
